import { MainColor } from '../../palette/colors';

export const getOfferDetailsThemeConfig = () => {
  return {
    deadlineColor: {
      default: 'navy95' as MainColor,
      warning: 'orange50' as MainColor,
      delayed: 'rose50' as MainColor,
    },
  };
};

export type OfferDetailsTheme = ReturnType<typeof getOfferDetailsThemeConfig>;
